import domReady from '@wordpress/dom-ready';

domReady(() => {
	const popinsNewsletter = document.querySelectorAll('.popin-newsletter');

	if (popinsNewsletter && popinsNewsletter.length) {
		popinsNewsletter.forEach((block) => {
			const popinNewsletterClose = block.querySelector('.popin-close');
			const body = document.querySelector('body');

			const closePopin = () => {
				block.classList.remove('is-visible');
				setTimeout(() => {
					body.classList.remove('is-freeze');
				}, 200);
			};

			block.addEventListener('click', (e) => {
				if (e.target.classList.contains('popin-newsletter')) {
					closePopin();
				}
			});

			popinNewsletterClose.addEventListener('click', () => {
				closePopin();
			});
		});
	}
});
